import React from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  styled,
  StepConnector,
  stepConnectorClasses
} from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';
import CustomCircularProgress from '../Loaders/CustomCircularProgress';

const CustomConnector = styled(StepConnector)(({ theme: muiTheme, ownerState, customtheme }) => ({
  // [`&.${stepConnectorClasses.alternativeLabel}`]: {
  //   top: 22,
  // },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: customtheme.color.primary,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: customtheme.color.primary,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: customtheme.border.medium,
    borderRadius: 1,
  },
}));

const CustomStepLabel = styled(StepLabel)(({ customtheme }) => ({
  '& .MuiStepLabel-label': {
    fontWeight: 'bold',
    fontFamily: customtheme.fontFamily,
    color: customtheme.text.tertiary,
    '&.Mui-active': {
      color: customtheme.color.primary,
    },
    '&.Mui-completed': {
      color: customtheme.color.secondary,
    },
  },
  '& .MuiStepLabel-iconContainer': {
    '& .MuiStepIcon-root': {
      fontWeight: 'bold',
      fontFamily: customtheme.fontFamily,
      color: customtheme.border.medium,
      '&.Mui-active': {
        color: customtheme.color.primary,
      },
      '&.Mui-completed': {
        color: customtheme.color.secondary,
      },
    },
  },
}));

const CustomStepProgressMobile = ({ step = 1, totalSteps = 6 }) => {
  const { theme } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        py: 2,
      }}
    >
      <CustomCircularProgress />
      <br />
      <Stepper
        activeStep={step - 1}
        alternativeLabel
        sx={{
          width: '100%',
          maxWidth: 400,
        }}
        connector={<CustomConnector customtheme={theme} />}
      >
        {[...Array(totalSteps)].map((_, index) => (
          <Step key={index}
            sx={{
              '& .MuiStepLabel-root': {
                fontFamily: theme.fontFamily,
                color: theme.color.primary
              },
              '& .MuiStepLabel-label': {
                color: index < step
                  ? theme.color.primary
                  : theme.text.secondary,
                '&.Mui-active': {
                  color: theme.color.primary,
                  fontWeight: 'bold',
                },
                '&.Mui-completed': {
                  color: theme.color.primary,
                },
              },
            }}
          >
            <CustomStepLabel customtheme={theme}/>
          </Step>
        ))}
      </Stepper>

      <Typography
        variant="body2"
        sx={{
          mt: 2,
          fontFamily: theme.fontFamily,
          color: theme.text.primary
        }}
      >
        Processing Step {step} of {totalSteps}
      </Typography>
    </Box>
  );
};

export default CustomStepProgressMobile;